
import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AlertSearchRestService
 *
 * @description
 * This class contains methods used to manage information about activation codes
 * using http requests.
 */
export default class AlertSearchRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
    * @ngdoc function
    * @name rest.services.AlertSearchRestService#getById
    * @methodOf rest.services.AlertSearchRestService
    * @function
    *
    * @description
    * Retrieves activation-code.
    *
    * @returns {Promise} The promise of the call.
    */
    getByEmail(email, lang) {

        return super.getAllAsync(`alert-search?filter[emails]=${email}&filter[language]=${lang}`);

    }

}

_serviceDependencies.push(AlertSearchRestService);

angular.module('rest.services')
    .service('AlertSearchRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/alertSearchRestService.js